var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.785,
    height: 30.484,
    viewBox: "0 0 17.785 30.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    transform: "translate(27.908 -4.5) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M22.872,10.5a1.27,1.27,0,0,1,1.8,0l7.62,7.62a1.27,1.27,0,0,1,0,1.8l-7.62,7.62a1.272,1.272,0,1,1-1.8-1.8l6.723-6.722-6.724-6.722a1.27,1.27,0,0,1,0-1.8Z",
    transform: "translate(2.321)",
    fill: "#6b6562",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M4.5,18.145a1.27,1.27,0,0,1,1.27-1.27H32.441a1.27,1.27,0,1,1,0,2.54H5.77A1.27,1.27,0,0,1,4.5,18.145Z",
    transform: "translate(0 0.871)",
    fill: "#6b6562",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBottom);
export default __webpack_public_path__ + "static/media/icon-arrow-bottom.e989f139313c44e88ceb125ce2bb9499.svg";
export { ForwardRef as ReactComponent };